export function getAxisValue(value) {
	const magnitude = Math.pow(10, Math.floor(Math.log10(Math.abs(value))));
	const sign = value >= 0 ? 1 : -1;

	return sign * Math.ceil(Math.abs(value) / magnitude) * magnitude;
}
